import React from "react";

import { IdXboxIntroStudioDataType } from "../../../../models/forms";
import { ReadOnlyFormItem } from "../appInfoModelsAndHelpers";
import { ReadOnlyForm } from "../ReadOnlyForm";

type ReadOnlyStudioProps = {
  dataInForm: IdXboxIntroStudioDataType;
};

const StudioConfig: Map<string, ReadOnlyFormItem> = new Map([
  ["studioName", {}],
  ["businessName", { title: "legallyRegisteredBusinessName" }],
  ["businessNumber", { title: "registeredBusinessNumber" }],
  [
    "isASoleProprietor",
    {
      mapper: (data: IdXboxIntroStudioDataType, localizedStrings: Map<string, string>) =>
        data.thisCompany?.includes("isSoleProprietor")
          ? localizedStrings.get("yes")
          : localizedStrings.get("no"),
    },
  ],
  [
    "actsAsA",
    {
      mapper: (data: IdXboxIntroStudioDataType, localizedStrings: Map<string, string>) =>
        data.thisCompanyActsAs?.map(item => localizedStrings.get(item)),
    },
  ],
  ["publicTrailersLinks", { title: "linksToPublicTrailers" }],
  ["studioWebsite", {}],
  ["middlewareEnginesUsed", {}],
  ["dunsNumber", {}],
]);

export const ReadOnlyStudio = ({ dataInForm }: ReadOnlyStudioProps) => {
  const extraStringsToLocalize = ["developer", "publisher", "yes", "no"];
  return (
    <ReadOnlyForm
      formConfig={StudioConfig}
      formData={dataInForm}
      extraStringsToLocalize={extraStringsToLocalize}
    />
  );
};
